import cx from 'classnames';

interface DetailsItemProps {
  value: React.ReactNode;
  label?: string;
  icon?: React.ReactNode | null;
}

const DetailsItem = ({ value, label, icon }: DetailsItemProps): React.ReactElement => {
  return (
    <div className={cx('flex text-neutral-950-opacity-80', { 'flex-col': !icon }, { 'flex-row items-center': !!icon })}>
      {label ? <p className="body-base">{label}</p> : null}
      <div className={cx('flex', { 'sub-header-base': !icon })}>
        {icon}
        {value}
      </div>
    </div>
  );
};

export default DetailsItem;
